import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#505050",
      d: "M20.324 2.018a1 1 0 0 1 1.126 1.316L15.3 20.84a1 1 0 0 1-1.802.183l-4.13-6.884-6.882-4.128a1 1 0 0 1 .183-1.801l17.506-6.152zM10.859 13.71l3.378 5.629 4.877-13.885zM4.169 9.27 9.8 12.65l8.257-8.258z"
    }, null, -1)
  ])))
}
export default { render: render }